<template>
    <div class="loginscreen">
        <div class="container-fluid login-container">
            <div class="containers">
                <div class="row header-login">
                    <div class="col-lg-3 col-md-2 col-sm-1 mobilescreencol">

                    </div>
                    <div class="col-lg-6 col-sm-10 col-md-8 col-xs-12 login-form-container">
                        <form class="login-form">
                            <h2 class="text-center acount-header">{{ $t('message.loginAccount') }}</h2>
                            <p class="login-paragraph text-center">{{ $t('message.pleaseEnterYourCredentialToLogin') }}
                            </p>
                            <div class="form-fields-container">
                                <div class="form-field">
                                    <label class="form-label">{{ $t('message.emailTelephoneNumber') }}<span
                                            class="required-asterisk"> *</span></label>
                                    <input type="text" v-model="userForm.email_or_phone"
                                        :class="{ 'is-invalid': isLogin && $v.userForm.email_or_phone.$error }"
                                        class="form-control form-control-lg form-input-login"
                                        :placeholder="$t('message.emailTelephoneNumber')" />
                                    <div v-if="isLogin && !$v.userForm.email_or_phone.required"
                                        class="invalid-feedback">
                                        {{ $t('message.yourEmailTelephoneNumberRequired') }}</div>
                                </div>
                                <div class="form-field">
                                    <label class="form-label">{{ $t('message.enterPassword') }}<span
                                            class="required-asterisk"> *</span></label>
                                    <div class="password-input-container">
                                        <input :type="showPassword ? 'text' : 'password'" v-model="userForm.password"
                                            autocomplete="off"
                                            :class="{ 'is-invalid': isLogin && $v.userForm.password.$error }"
                                            class="form-control form-control-lg form-input-login" 
                                            :placeholder="$t('message.enterPassword')" />
                                        <i class="password-toggle-icon"
                                            :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"
                                            @click="togglePasswordVisibility"></i>
                                    </div>

                                    <div v-if="isLogin && !$v.userForm.password.required" class="invalid-feedback">
                                        {{ $t('message.yourPasswordRequired') }}</div>
                                </div>
                                <div class="forgot-password-container">
                                    <router-link to="/forgot-password" class="forgot-password-link">
                                        {{ $t('message.forgotPassword') }}
                                    </router-link>
                                </div>
                                <div class="login-button-container">
                                    <v-btn :disabled="disabled" @click="addLogin"
                                        class="login-button text-capitalize" color="#DE5D0A"
                                        height="50px">
                                        <span v-if="!disabled" class="login-button-text">
                                            {{ $t(titleLogin) }}
                                        </span>
                                        <div v-else class="loader-container">
                                            <div class="loader"></div>
                                        </div>
                                    </v-btn>
                                </div>
                                <div class="register-link-container">
                                    <p class="register-text">
                                        {{ $t('message.donotHaveAccountRegister') }}<router-link to="/register" class="register-link"> 
                                            <span>{{ $t('message.register') }}</span>
                                        </router-link>
                                    </p>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="col-lg-3 col-md-2 col-sm-1 mobilescreencol">

                    </div>

                </div>
            </div>
        </div>

    </div>
</template>
<script>
import {
    required
} from "vuelidate/lib/validators";
import axios from "axios";
export default {
    data() {
        return {
            userForm: {
                email_or_phone: "",
                password: "",
            },
            isLogin: false,
            disabled: false,
            titleLogin: 'message.login',
            showPassword: false,
        }
    },
    validations: {
        userForm: {
            email_or_phone: { required },
            password: { required },
        },
    },
    methods: {
        addLogin() {
            this.isLogin = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            } else {
                this.disabled = true;
                this.titleLogin = "Loading";
                const data = {
                    'username': this.userForm.email_or_phone,
                    'password': this.userForm.password,
                }
                const url = this.$url + `user-register/login`;
                let config = {
                    method: "POST",
                    headers: {
                        ...this.$header,
                        "Content-Type": "multipart/form-data"
                    },
                    data: data,
                    url,
                };
                axios(config).then((response) => {
                    if (response.status == 200) {
                        this.disabled = false;
                        this.titleLogin = 'message.login';
                        if (response.data.header.result == true && response.data.header.statusCode == 200) {
                            if (response.data.body.status == true) {
                                localStorage.setItem('session_start_login', response.data.body.message);

                                // Retrieve the stored redirect URL
                                const redirectUrl = localStorage.getItem('redirect_after_login') || '/';
                                // Clear the stored redirect URL to prevent future redirects
                                localStorage.removeItem('redirect_after_login');

                                setTimeout(() => {
                                    this.$router.push(redirectUrl + "?loginSuccess=1");
                                }, 500);
                            } else {
                                alert(response.data.body.message);
                            }
                        } else {
                            alert("Invalid username or password");
                        }
                    }
                }).catch((error) => {
                    console.log(error);
                });
            }

        },
        handleKeydown(event) {
            if (event.key === 'Enter') {
                this.addLogin();
            }
        },
        scrollToTop() {
            window.scrollTo(0, 0);
        },
        togglePasswordVisibility() {
            this.showPassword = !this.showPassword;
        },
    },
    mounted() {
        document.addEventListener('keydown', this.handleKeydown);
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.handleKeydown);
    },
    created() {
        this.scrollToTop();
    }
}
</script>
<style scoped>
.loginscreen {
    padding-top: 55px;
    min-height: calc(110vh - 320px);
    display: flex;
    flex-direction: column;
    position: relative;
    background: #f2f2f2;
}

.login-container {
    flex: 1;
    width: 100%;
    padding: 28px 0;
}

.containers {
    height: 100%;
}

.header-login {
    min-height: 100%;
    padding: 35px 0 70px 0;
    margin: 0;
}

.login-form-container {
    background: #FFFFFF;
    border-radius: 15px;
    padding: 40px 20px;
    height: fit-content;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    max-width: 450px;
    margin: 0 auto;
}

.login-form {
    width: 100%;
}

.form-fields-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
}

.form-field {
    width: 91%;
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.invalid-feedback{
    margin-top: 5px;
    width: 100%;
    text-align: left;
    color: #FF0000;
    margin-left: 10px;
}

.form-label {
    font-weight: bold;
    color: #333;
    margin-bottom: 8px;
    width: 100%;
    text-align: left;
}

.required-asterisk {
    color: #FF0000;
    padding-left: 2px;
}

.form-input-login {
    width: 100%;
    border: 1px solid #C6C6C6;
    border-radius: 6px;
    height: 45px;
    outline: none;
    padding-left: 12px;
    padding-right: 12px;
}

.forgot-password-container {
    width: 91%;
    text-align: right;
    margin-bottom: 20px;
}

.forgot-password-link {
    color: #FF0000;
    font-weight: 600;
    text-decoration: none;
}

.login-button-container {
    width: 91%;
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
}

.login-button {
    width: 100%;
    border-radius: 4px;
    background-color: #DE5D0A !important;
    color: white !important;
}

.login-button-text {
    color: #FFFFFF;
    font-size: 18px;
    font-weight: 600;
}

.register-link-container {
    width: 100%;
    text-align: center;
}

.register-text {
    color: #6A6969;
    font-size: 16px;
    margin: 0;
}

.register-link {
    text-decoration: none;
}

.register-link span {
    color: #DE5D0A;
    font-weight: 600;
}

.password-input-container {
    position: relative;
    width: 100%;
}

.password-toggle-icon {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    color: #6A6969;
}

@media(min-width: 1740px) {}

@media(width < 1024px) {}

@media screen and (width < 950px) {
    /* .loginscreen {
            margin-top: -20px;
        } */
    /* .mobilescreencol{
            display: none !important;
        } */


}

@media screen and (width < 620px) {

    /* .loginscreen {
            margin-top: -20px;
        } */
    /* .mobilescreencol{
            display: none !important;
        } */
    .header-login {
        padding-top: 20px;
        padding-bottom: 40px;
        opacity: 1;
    }

    .acount-header {
        margin-top: 10px;
    }

    .emailmargin {
        /* margin-left: 5px; */

    }

    .form-input-login,
    .inner-block,
    .btn-width {
        /* width: 97% !important; */
    }

    .forgetPasswordform {
        /* width: 99%; */
    }

    .loader {
        width: 24px;
    }
}

@media screen and (width < 500px) {

    /* .loginscreen {
            margin-top: -20px;
        } */
    .mobilescreencol {
        display: none !important;
    }

    .header-login {
        padding-top: 20px;
        padding-bottom: 40px;
        opacity: 1;
    }

    .acount-header {
        margin-top: 10px;
    }

    .emailmargin {
        /* margin-left: 5px; */

    }

    .form-input-login,
    .inner-block,
    .btn-width {
        /* width: 97% !important; */
    }

    .forgetPasswordform {
        /* width: 99%; */
    }
}

@media(width < 450px) {

    /* .loginscreen {
            margin-top: -20px;
        } */
    .mobilescreencol {
        display: none !important;
    }

    .header-login {
        padding-top: 20px;
        padding-bottom: 40px;
        opacity: 1;
    }

    .acount-header {
        margin-top: 10px;
    }

    .emailmargin {
        /* margin-left: 5px; */

    }

    .form-input-login,
    .inner-block,
    .btn-width {
        /* width: 97% !important; */
    }

    .forgetPasswordform {
        /* width: 99%; */
    }

}

@media screen and (width < 438px) {
    /* .loginscreen {
            margin-top: -20px;
        } */


    .mobilescreencol {
        display: none !important;
    }

    .header-login {
        padding-top: 20px;
        padding-bottom: 40px;
        opacity: 1;
    }

    .acount-header {
        margin-top: 10px;
    }

    .emailmargin {
        /* margin-left: 5px; */

    }

    .form-input-login,
    .inner-block,
    .btn-width {
        /* width: 97% !important; */
    }

    .forgetPasswordform {
        /* width: 99%; */
    }
}

.loader-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
}

.loader {
    width: 120px;
    height: 4px;
    background: linear-gradient(#2c2a2a 0 0) 0/0% no-repeat rgba(255, 255, 255, 0.2);
    animation: loading 2s infinite linear;
}

@keyframes loading {
    100% {
        background-size: 100%;
    }
}
</style>